exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remove-from-cart{cursor:pointer;text-align:center}.remove-from-cart img{width:12px}.img-container{border:1px solid #cfcfcf;position:relative;padding-bottom:100%;background-color:#fff}.img-container img{position:absolute;top:15px;left:0;height:calc(100% - 30px);width:calc(100% - 30px);-o-object-fit:contain;object-fit:contain;background-color:#fff}", ""]);

// exports
